import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useRegistrations} from '../hooks/useRegistrations.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useRegistrations();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};